import { getIdToken } from "@/services/Auth";
import type { CreativeXDimensions, CreativeXSecret } from "@/types/preflight/creativeX";
import { getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";

export async function getCreativeXDimensions(baseUrl: string, secretId?: string) {
    const url = `${baseUrl}/v1/creativex/dimensions${secretId ? `?secretId=${secretId}` : ""}`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<CreativeXDimensions>(url, headers);
}

export async function getCreativeXSecrets(baseUrl: string) {
    const url = `${baseUrl}/v1/creativex/secrets`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<CreativeXSecret[]>(url, headers);
}
